import { ArgsType } from '@nestjs/graphql'
import { MaxLength, MinLength } from '@nestjs/class-validator'
import { bsConstants } from '../../../module.constants'

@ArgsType()
export class ResetPasswordDto {
  oldPassword!: string

  @MinLength(bsConstants.USER.PASSWORDS.MIN_LENGTH, { message: 'minPasswordLength' })
  @MaxLength(bsConstants.USER.PASSWORDS.MAX_LENGTH, { message: 'maxPasswordLength' })
  newPassword!: string
}
